export const formatDecimal = (value) => {
    if (value === "") return "";

    let cleaned = value.replace(/[^0-9.]/g, "");
  
    const parts = cleaned.split(".");
    if (parts.length > 2) {
        cleaned = parts[0] + "." + parts.slice(1).join("");
    }

    let [integer, decimal] = cleaned.split(".");

    if (integer) {
        integer = integer.slice(0, 5);
    }

    if (decimal) {
        decimal = decimal.slice(0, 3);
    }

    return decimal !== undefined ? `${integer}.${decimal}` : integer;
};